/** CDN URL'leri zaten ? içeriyorsa imgix benzeri parametreleri & ile ekler. Instagram CDN parametre eklemez. */
export function withCropParams(url, w = 800) {
  if (!url) return '';
  try {
    const u = new URL(url, 'https://placeholder.local');
    const h = u.hostname || '';
    if (
      h.includes('cdninstagram') ||
      h.includes('fbcdn.net') ||
      h.includes('firebasestorage.googleapis.com')
    ) {
      return url;
    }
  } catch {
    /* devam */
  }
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}auto=format&fit=crop&w=${w}&q=80`;
}
